import { H2, LoadingIndicator } from '@triumph/design-system';
import { Button } from 'primereact/button';
import { useEffect, useRef, useState } from 'react';

import { CenteredContainer } from '@/components/router/PageRouter.StyledComponents';
import { getHangfireDashboardRedeemUrl } from '@/components/shared/api/endpoints/hangfireDashboard';
import { useCreateHangfireDashboardSessionMutation } from '@/components/shared/api/mutations/hangfireDashboard';

export const HangfireDashboardRedirect = () => {
    const { mutateAsync: createHangfireDashboardSession } =
        useCreateHangfireDashboardSessionMutation();
    const [hasFailed, setHasFailed] = useState(false);
    const hasRequestedCode = useRef(false);

    // Awaited rather than mutate's onSuccess, which StrictMode's remount detaches before it fires.
    const redirectToDashboard = async () => {
        setHasFailed(false);
        try {
            const { code } = await createHangfireDashboardSession();
            // Replace, so Back from the dashboard skips this page instead of minting another code.
            window.location.replace(getHangfireDashboardRedeemUrl(code));
        } catch {
            setHasFailed(true);
        }
    };

    useEffect(() => {
        // StrictMode runs effects twice in development, and the second code would expire unused.
        if (hasRequestedCode.current) return;
        hasRequestedCode.current = true;
        void redirectToDashboard();
    }, []);

    if (hasFailed) {
        return (
            <CenteredContainer>
                <H2>We couldn't open the Hangfire Dashboard.</H2>
                <Button
                    label="Try Again"
                    severity="info"
                    onClick={redirectToDashboard}
                    data-testid="hangfire-dashboard-retry"
                />
            </CenteredContainer>
        );
    }

    return (
        <CenteredContainer data-testid="hangfire-dashboard-redirecting">
            <LoadingIndicator show />
        </CenteredContainer>
    );
};
